module.exports = __webpack_public_path__ + "media/images/logos/logo-lapis-7ea105329332c0daa6cf1dfd79d9f667.svg";